import { LoggerFactory, ILogger } from '../helpers';
import { Rgba } from './rgba';
import { IColorHelper } from './IColorHelper';


export class ColorHelper implements IColorHelper {
    private _logger: ILogger;
    constructor() {
        this._logger = LoggerFactory.getLogger('WideTech.Helpers.colorHelper', false, 0);
    }

    hexToRgb(hexValue: string): Rgba {
        const converted = new Rgba(0, 0, 0, 0);
        let reducedHex: string;
        if (hexValue.length === 4) {
            converted.a = 1;
            reducedHex = hexValue.substring(1, 2) + hexValue.substring(1, 2) + hexValue.substring(2, 3)
                + hexValue.substring(2, 3) + hexValue.substring(3, 4) + hexValue.substring(3, 4);
        }
        if (hexValue.length === 6) {
            converted.a = 1;
            reducedHex = hexValue;
        } else if (hexValue.length === 7) {
            converted.a = 1;
            reducedHex = hexValue.substring(1, 7);
        } else if (hexValue.length === 8) {
            converted.a = parseInt(hexValue.substring(0, 2), 16) / 255;
            reducedHex = hexValue.substring(2, 8);

        } else if (hexValue.length === 9) {
            converted.a = parseInt(hexValue.substring(1, 3), 16) / 255;
            reducedHex = hexValue.substring(3, 9);
        } else {
            this._logger.warning('HEX value is not in a correct format');
        }
        if (reducedHex) {
            converted.r = parseInt(reducedHex.substring(0, 2), 16);
            converted.g = parseInt(reducedHex.substring(2, 4), 16);
            converted.b = parseInt(reducedHex.substring(4, 6), 16);
        }
        return converted;
    }

    rgbaToHex(r: number, g: number, b: number, a: number): string {
        const hex = '#' + this.componentToHex(r) + this.componentToHex(g) + this.componentToHex(b);
        return hex;
    }

    private componentToHex(c) {
        const hex = c.toString(16);
        return hex.length === 1 ? '0' + hex : hex;
    }
}